var _path, _path2, _path3;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgHorlogePeriode(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "MuiSvgIcon-root MuiSvgIcon-fontSizeLarge  css-c1sh5i",
    focusable: "false",
    "aria-hidden": "true",
    viewBox: "0 0 24 24",
    "data-testid": "MoreTimeIcon",
    "aria-label": "fontSize large",
    fill: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 8v6l4.7 2.9.8-1.2-4-2.4V8z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.92 12c.05.33.08.66.08 1 0 3.9-3.1 7-7 7s-7-3.1-7-7 3.1-7 7-7c.7 0 1.37.1 2 .29V4.23c-.64-.15-1.31-.23-2-.23-5 0-9 4-9 9s4 9 9 9 9-4 9-9c0-.34-.02-.67-.06-1z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20 5V2h-2v3h-3v2h3v3h2V7h3V5z"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHorlogePeriode);
export default __webpack_public_path__ + "static/media/HorlogePeriode.de5ef81a.svg";
export { ForwardRef as ReactComponent };